import React from 'react';
import SectionShell from '../SectionShell';
import Reveal from '../Reveal';
import { useT } from '../../i18n/LanguageContext';

/**
 * Folie 20 — "Aus Rabatten werden Ersparnisse".
 * Layout: image53 (Lifestyle: Abos + Digital Wallet + Auto-Leasing) links,
 * kleiner italic Body-Text rechts + 4 gleich große Highlight-Zeilen
 * (3 Rechenschritte + $300 Ergebnis in Gold).
 */
export default function SectionErsparnisse() {
  const { t } = useT();
  return (
    <SectionShell id="ersparnisse" className="" centerContent>
      <Reveal>
        <div
          data-testid="vip-example"
          className="hairline rounded-sm p-8 md:p-10 grid grid-cols-1 md:grid-cols-[1.35fr_1fr] gap-8 md:gap-12 items-center bg-white/[0.012]"
        >
          {/* LEFT — original PPTX image53 (gecroppt, füllt die Spalte) */}
          <div className="relative order-2 md:order-1 overflow-visible flex items-center justify-center">
            <img
              src="/source-pptx/image53.png"
              alt="Aus Rabatten werden Ersparnisse — Lifestyle"
              loading="lazy"
              draggable={false}
              className="block w-full h-auto object-contain select-none rounded-sm mx-auto"
              style={{ filter: 'drop-shadow(0 22px 44px rgba(0,0,0,0.55))' }}
            />
          </div>

          {/* RIGHT — headline + body + 4 equal highlight rows */}
          <div className="order-1 md:order-2">
            <div className="overline mb-6 text-base">{t.vip.example.title}</div>
            <p className="font-ui text-xl md:text-2xl text-white/70 leading-relaxed italic mb-10 whitespace-pre-line">
              {t.vip.example.body}
            </p>

            <div className="space-y-4" data-testid="vip-example-lines">
              <HighlightRow label={t.vip.example.line1Label} value={t.vip.example.line1Value} />
              <HighlightRow label={t.vip.example.line2Label} value={t.vip.example.line2Value} />
              <HighlightRow label={t.vip.example.line3Label} value={t.vip.example.line3Value} />
              <HighlightRow
                label={t.vip.example.resultLabel}
                value={t.vip.example.resultValue}
                emphasis
              />
            </div>
          </div>
        </div>
      </Reveal>
    </SectionShell>
  );
}

function HighlightRow({ label, value, emphasis = false }) {
  return (
    <div
      className={`flex items-center justify-between gap-4 px-6 py-5 rounded-sm hairline ${
        emphasis
          ? 'bg-[rgba(212,175,55,0.06)] border-[rgba(212,175,55,0.35)]'
          : 'bg-white/[0.02]'
      }`}
      data-testid={emphasis ? 'vip-example-result' : 'vip-example-row'}
    >
      <span className={`font-ui text-lg md:text-xl ${emphasis ? 'text-[#f2d979]' : 'text-white/70'}`}>
        {label}
      </span>
      <span
        className={`font-display text-3xl md:text-4xl tracking-tight ${
          emphasis ? 'text-[#f2d979]' : 'text-white'
        }`}
      >
        {value}
      </span>
    </div>
  );
}
